import { IQuestionsGroupProps } from 'app/components/questions/base'
import { RetirementIntro } from 'app/containers/PipelineSection/Retirement/Introduction'
import { RetirementInvestmentReturns } from 'app/containers/PipelineSection/Retirement/InvestmentReturns'
import { Local697MemberContributionsQuestionsGroup } from 'app/containers/PipelineSection/Retirement/Local697MemberSavings'
import { RetirementMemberContributionsQuestionsGroup } from 'app/containers/PipelineSection/Retirement/MemberContributions'
import { RetirementMemberWithdrawalQuestionsGroup } from 'app/containers/PipelineSection/Retirement/MemberWithdrawal'
import { RetirementSpouseContributionsQuestionsGroup } from 'app/containers/PipelineSection/Retirement/SpouseContributions'
import { RetirementSpouseWithdrawalQuestionsGroup } from 'app/containers/PipelineSection/Retirement/SpouseWithdrawal'
import { RetirementSummary } from 'app/containers/PipelineSection/Retirement/Summary'

interface IRetirementQuestionGroups {
  RetirementIntro: () => React.ReactElement<IQuestionsGroupProps>
  RetirementInvestmentReturns: () => React.ReactElement<IQuestionsGroupProps>
  Local697MemberContributionsQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  RetirementMemberContributionsQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  RetirementMemberWithdrawalQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  RetirementSpouseContributionsQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  RetirementSpouseWithdrawalQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  RetirementSummary: () => React.ReactElement<IQuestionsGroupProps>
}

const RetirementQuestionGroups: IRetirementQuestionGroups = {
  RetirementIntro,
  RetirementInvestmentReturns,
  Local697MemberContributionsQuestionsGroup,
  RetirementMemberContributionsQuestionsGroup,
  RetirementMemberWithdrawalQuestionsGroup,
  RetirementSpouseContributionsQuestionsGroup,
  RetirementSpouseWithdrawalQuestionsGroup,
  RetirementSummary,
}

type RetirementQuestionGroupsKeys = keyof IRetirementQuestionGroups

export {
  IRetirementQuestionGroups,
  RetirementQuestionGroups,
  RetirementQuestionGroupsKeys,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/index.tsx